import CompletedBookings from '@commons/bookings/completed'

const UserCompletedBookings = ({ user }) => {
  return <CompletedBookings user={user} />
}

export default UserCompletedBookings
